"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseInitRequest = void 0;
var PurchaseInitRequest = /** @class */ (function () {
    function PurchaseInitRequest() {
    }
    return PurchaseInitRequest;
}());
exports.PurchaseInitRequest = PurchaseInitRequest;
;
//# sourceMappingURL=purchaseInit.request.js.map